import React, { useState, useEffect } from "react";
import "./ActiveVendors.css";

// Checkbox MultiSelect Component
const CheckboxMultiSelect = ({ name, options, selectedValues, onChange, resetCheckboxes }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [tempSelectedValues, setTempSelectedValues] = useState(
    Array.isArray(selectedValues) ? selectedValues : []
  );

  const handleCheckboxChange = (value) => {
    const updatedValues = tempSelectedValues.includes(value)
      ? tempSelectedValues.filter((v) => v !== value)
      : [...tempSelectedValues, value];
    setTempSelectedValues(updatedValues);
  };

  const handleApplyChanges = () => {
    onChange(name, tempSelectedValues);
    setIsOpen(false);
  };

  useEffect(() => {
    setTempSelectedValues(selectedValues); // Sync local state with parent state
  }, [selectedValues]);

  const resetLocalState = () => {
    setTempSelectedValues([]); // Reset local state
    if (resetCheckboxes) resetCheckboxes(); // Call parent reset function
  };

  return (
    <div
      className="custom-multi-select"
      id="ActiveVendor-Checkbox"
      style={{ position: "relative" }}
    >
      <div
        className="form-control Activevendordropdown-toggle"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        style={{
          cursor: "pointer",
          width: "100%",
         
        }}
      >
        {tempSelectedValues.length > 0
          ? tempSelectedValues.join(", ")
          : `Select ${name}`}
      </div>
      {isOpen && (
        <div className="Activevendordropdown-menu">
          {options.map((option, index) => (
            <div key={index} className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id={`${name}_${index}`}
                value={option}
                checked={tempSelectedValues.includes(option)}
                onChange={() => handleCheckboxChange(option)}
              />
              <label className="form-check-label" htmlFor={`${name}_${index}`}>
                {option}
              </label>
            </div>
          ))}
          <div className="dropdown-footer">
            <button className="btn-apply" onClick={handleApplyChanges}>
              ✓ Apply
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

// Filter Section Component
const FilterSection = ({
  field,
  displayedOptions,
  filterSelections,
  handleFilterChange,
  isSingleSelection,
  setFilterSelections,
  setFilteredVendorData,
  filteredVendors,
}) => {
  const clearFilters = () => {
    setFilterSelections({}); // Reset all filter selections
    setFilteredVendorData(filteredVendors); // Reset filtered data to original dataset

    // Clear dropdown values
    document.querySelectorAll("select").forEach((select) => (select.value = ""));

    // Clear checkbox filters
    if (field.fieldType === "checkbox") {
      handleFilterChange(field.fieldName, []); // Clear parent state for checkboxes
    }
  };

  return (
    <div className="filter-section item-center flex flex-col" style={{ justifyContent: "space-evenly" }}>
      <div className="text-sm mb-2">
      <strong className="text-xs" style={{ fontSize: "12px" }}>{field.fieldLabel}</strong>
      </div>
      <div className="filter-options flex flex-col space-y-4">
        {isSingleSelection ? ( <>
         <select
         className="w-[151px] rounded-[5px] border border-[#ddd] text-[10px] box-border"
         onChange={(e) => handleFilterChange(field.fieldName, e.target.value, true)}
         style={{ padding: "10px ", marginBlock: "0px", border:" 2px solid #ced4da",
            borderRadius:"0.35rem" }}
       >
            <option value="">Select {field.fieldLabel}</option>
            {displayedOptions.map((option, idx) => (
              <option key={idx} value={option}>
                {option}
              </option>
            ))}
          </select>
          <div className="clear-btn-container mt-2">
          <button
            style={{
              padding: "0.5rem 1rem",
              backgroundColor: "transparent",
              border: "2px solid #f87171", // Tailwind's red-500 color
              color: "#f87171", // Tailwind's red-500 color
              borderRadius: "0.5rem",
              transition: "background-color 0.3s ease",
            }}
            onClick={clearFilters} // Call clearFilters
            onMouseOver={(e) => (e.target.style.backgroundColor = "#fef2f2")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "transparent")}
          >
            Clear Filters
          </button>
        </div>
       </>
        ) : (<>
          <CheckboxMultiSelect
            name={field.fieldName}
            options={displayedOptions}
            selectedValues={filterSelections[field.fieldName] || []}
            onChange={handleFilterChange}
            resetCheckboxes={() =>
              setFilterSelections({ ...filterSelections, [field.fieldName]: [] })
            }
          />
          <div className="clear-btn-container mt-2">
          <button
            style={{
              padding: "0.5rem 1rem",
              backgroundColor: "transparent",
              border: "2px solid #f87171", // Tailwind's red-500 color
              color: "#f87171", // Tailwind's red-500 color
              borderRadius: "0.5rem",
              transition: "background-color 0.3s ease",
            }}
            onClick={clearFilters} // Call clearFilters
            onMouseOver={(e) => (e.target.style.backgroundColor = "#fef2f2")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "transparent")}
          >
            Clear Filters
          </button>
        </div></>
        )}
        
      </div>
    </div>
  );
};

// Dynamic FilterBar Component
const DynamicFilterBar = ({
  categoryFields,
  filterSelections,
  handleFilterChange,
  setFilterSelections,
  setFilteredVendorData,
  filteredVendors,
  categoryName, // Pass category name as prop
}) => {
  // Allowed fields for the "VENUE" category
  const venueFields = ["NoOfRooms", "NoOfGuests", "SpecialBadges", "Catering", "Decoration"];

  // Filter fields based on category
  const filteredFields =
    categoryName === "VENUE"
      ? categoryFields.filter((field) => venueFields.includes(field.fieldName))
      : categoryFields; // Show all fields for other categories

  return (
    <div
      className="filter-bar d-flex"
      style={{ gap: "20px", alignItems: "center", flexWrap: "wrap" }}
    >
      {filteredFields.map((field, index) => {
        const isSingleSelection = field.fieldType === "select";
        const displayedOptions = field.options;

        return (
          <FilterSection
            key={index}
            field={field}
            displayedOptions={displayedOptions}
            filterSelections={filterSelections}
            handleFilterChange={handleFilterChange}
            setFilterSelections={setFilterSelections}
            setFilteredVendorData={setFilteredVendorData}
            filteredVendors={filteredVendors}
            isSingleSelection={isSingleSelection}
          />
        );
      })}
    </div>
  );
};


export default DynamicFilterBar;
